/* Extracted from snippets/gnc-variant-modal.liquid. Self-contained IIFE with
   delegated document listeners and lazy init, so it is a safe no-op on pages
   that have no modal. Contains no Liquid. */
/* ═══════════════════════════════════════════════════════════════
   GNC Variant Modal JS
   ─ Fully self-contained IIFE — no globals leaked.
   ─ Lazy-init: setupModal() only runs on first "Change" tap.
   ─ No extra fetch — all data is from the inline JSON above.
   ─ KG/LB proxies to existing #checkbox-lbskgs so no logic dup.
   ─ INP-safe: no heavy work on click; rAF used for DOM mutations.
═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var _inited = {};

  /* ── helpers ──────────────────────────────────────────────── */
  function fmtMoney(paise) {
    var r = paise / 100;
    return '\u20B9' + r.toLocaleString('en-IN', { maximumFractionDigits: 2, minimumFractionDigits: 0 });
  }
  function discPct(price, mrp) {
    return (mrp && mrp > price) ? Math.round((mrp - price) / mrp * 100) : 0;
  }
  /* LB → KG label, same substring order as the Liquid kgs_equiv chain so
     compound sizes ("1lbs Pack of 2") convert too. */
  function toKgs(opt) {
    return opt.replace('8.81 lbs', '4 kg').replace('5 lbs', '2.27 kg').replace('4 lbs', '1.81 kg')
              .replace('2 lbs', '907 g').replace('1 lbs', '450 g').replace('1lbs', '450 g');
  }
  /* <sale-price>/<compare-at-price> hold an sr-only label + a text node; swap
     only the text so the label survives. */
  function setPriceText(el, text) {
    if (!el) return;
    var last = el.lastChild;
    if (last && last.nodeType === 3) last.textContent = text;
    else el.appendChild(document.createTextNode(text));
  }

  /* ── open / close ─────────────────────────────────────────── */
  function openModal(pid) {
    var modal   = document.getElementById('gnc-vm-modal-' + pid);
    var openBtn = document.getElementById('gnc-vm-open-' + pid);
    if (!modal) return;
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    modal.removeAttribute('hidden');
    document.body.classList.add('gnc-vm-body-lock');
    /* Sync the KG/LB toggle to whatever the page checkbox currently is */
    syncUnitToggle(modal);
    requestAnimationFrame(function () {
      var close = modal.querySelector('.gnc-vm-close');
      if (close) close.focus();
      revealSelected(modal);
    });
  }

  /* Scroll each horizontally-scrolling option row so its selected pill is in
     view -- e.g. the 4th size card (35 gm) sat off-screen on open. Sets
     scrollLeft directly: scrollIntoView would also scroll the page/sheet. */
  function revealSelected(root) {
    root.querySelectorAll('.gnc-vm-pills').forEach(function (row) {
      if (row.scrollWidth <= row.clientWidth) return;
      var pill = row.querySelector('.gnc-vm-pill--selected');
      if (!pill) return;
      var r = row.getBoundingClientRect(), p = pill.getBoundingClientRect();
      /* The Size row has scroll-snap: a nudge of a few px snaps straight back,
         so land on a card's start (its snap point) instead -- the first one that
         brings the whole pill into view (GNC-BUG-58). */
      var origin = r.left - row.scrollLeft;
      if (p.left < r.left) {
        row.scrollLeft = p.left - origin;
      } else if (p.right > r.right) {
        var need = p.right - origin - row.clientWidth;
        var cards = row.querySelectorAll('.gnc-vm-pill:not([hidden])');
        for (var i = 0; i < cards.length; i++) {
          var start = cards[i].getBoundingClientRect().left - origin;
          if (start >= need) { row.scrollLeft = start; break; }
        }
      }
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    var sheet = modal.querySelector('.gnc-vm-sheet');
    var pid   = modal.id.replace('gnc-vm-modal-', '');
    var done  = false;

    function finalize() {
      if (done) return;
      done = true;
      modal.setAttribute('hidden', '');
      document.body.classList.remove('gnc-vm-body-lock');
      if (sheet) sheet.classList.remove('gnc-vm-sheet--closing');
      var openBtn = document.getElementById('gnc-vm-open-' + pid);
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus({ preventScroll: true }); }

    }

    if (sheet) {
      sheet.classList.add('gnc-vm-sheet--closing');
      sheet.addEventListener('animationend', function handler() {
        sheet.removeEventListener('animationend', handler);
        finalize();
      });
      setTimeout(finalize, 400); /* safety fallback */
    } else {
      finalize();
    }
  }

  /* Mirrors applyUnitVisibility() in variant-picker.liquid, scoped to the modal
     so it cannot disturb anything else on the page. Only used when that
     component is absent (the quick-buy drawer). */
  function applyUnitClassesDirect(isKgs, scope) {
    var root = scope || document;
    root.querySelectorAll('.option-kgs').forEach(function (el) {
      el.classList.toggle('hidden', !isKgs);
    });
    root.querySelectorAll('.option-lbs').forEach(function (el) {
      el.classList.toggle('hidden', isKgs);
    });
  }

  function syncUnitToggle(modal) {
    var cb = document.getElementById('checkbox-lbskgs');
    if (!cb) return;
    /* #checkbox-lbskgs checked = KGS shown. data-unit now matches the label. */
    var unit = cb.checked ? 'kg' : 'lb';
    modal.querySelectorAll('.gnc-vm-unit-btn').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.unit === unit);
    });
  }

  /* ── lazy per-product wiring ──────────────────────────────── */
  /* inlineEl: the drawer's inline modal. Its ids are per product, so a second
     quick-buy drawer for the same product (PLP card + search card) duplicates
     them -- getElementById then wired the first copy and the visible drawer's
     pills did nothing. Inline lookups stay inside the drawer's own
     <product-rerender>. */
  function setupModal(pid, inlineEl) {
    var scope  = inlineEl ? (inlineEl.closest('product-rerender') || inlineEl.parentNode) : null;
    var byId   = function (id) {
      return scope ? scope.querySelector('[id="' + id + '"]') : document.getElementById(id);
    };
    var dataEl = byId('gnc-vm-data-' + pid);
    var modal  = inlineEl || document.getElementById('gnc-vm-modal-' + pid);
    if (!dataEl || !modal) return false;

    var data    = JSON.parse(dataEl.textContent);
    var isInline = !!inlineEl;
    var getForm = function () { return byId(data.formId); };
    var lastIdx = data.options.length - 1;
    /* Offer label lives on the Size cards (Figma); products without a Size
       option keep it on the last option. */
    var labelIdx = (data.sizeOptIndex >= 0) ? data.sizeOptIndex : lastIdx;

    /* ─ state ─ */
    var initV = data.variants.find(function (v) { return v.id === data.selectedVariantId; })
                || data.variants[0];
    var state = { opts: initV.options.slice(), vid: initV.id };
    var _syncTimer = null;
    var _notifiedVariants = {};  /* tracks variant IDs that user already submitted Notify Me for */

    /* ─ resolve best variant when option[idx] is set to val ─ */
    function bestVariant(idx, val) {
      var test = state.opts.slice();
      test[idx] = val;
      /* 1. Exact match — all options stay the same except the changed one (prefer available) */
      var exact = data.variants.find(function (v) {
        return test.every(function (o, i) { return v.options[i] === o; }) && v.available;
      }) || data.variants.find(function (v) {
        return test.every(function (o, i) { return v.options[i] === o; });
      });
      if (exact) return exact;
      /* 2. Fallback — match options up to idx, allow later options to differ */
      return (
        data.variants.find(function (v) {
          return test.every(function (o, i) { return i > idx || v.options[i] === o; }) && v.available;
        }) ||
        data.variants.find(function (v) {
          return test.every(function (o, i) { return i > idx || v.options[i] === o; });
        }) ||
        null
      );
    }

    /* ─ update footer pricing / image / variant text ─ */
    function updateFooter() {
      var v = data.variants.find(function (v) { return v.id === state.vid; });
      if (!v) return;
      var el;

      el = modal.querySelector('.gnc-vm-footer-variant');
      if (el) {
        var showKgs = false;
        var cb = document.getElementById('checkbox-lbskgs');
        if (cb) showKgs = cb.checked;
        else { var ab = modal.querySelector('.gnc-vm-unit-btn.active'); showKgs = !!(ab && ab.dataset.unit === 'kg'); }
        var converted = v.options.map(function (opt) {
          return showKgs ? toKgs(opt) : opt;
        });
        var t = converted.join(' \u00B7 ');
        if (v.servings) t += ' (' + v.servings + ')';
        el.textContent = t;
      }

      el = modal.querySelector('.gnc-vm-footer-price');
      if (el) el.textContent = fmtMoney(v.price);

      var mrpEl = modal.querySelector('.gnc-vm-footer-mrp');
      var offEl = modal.querySelector('.gnc-vm-footer-off');
      if (mrpEl && offEl) {
        var d = discPct(v.price, v.compareAtPrice);
        if (d > 0) {
          mrpEl.textContent = fmtMoney(v.compareAtPrice);
          offEl.textContent = d + '% off';
          mrpEl.hidden = offEl.hidden = false;
        } else {
          mrpEl.hidden = offEl.hidden = true;
        }
      }

      el = modal.querySelector('.gnc-vm-footer-img');
      if (el && v.featuredImageUrl) el.src = v.featuredImageUrl;

      /* Update ATC button price */
      var mainPriceEl = modal.querySelector('.buybutton-main-price');
      if (mainPriceEl) mainPriceEl.textContent = fmtMoney(v.price);
      var cpEl = modal.querySelector('.buybutton-compareat-price');
      if (cpEl) {
        if (v.compareAtPrice > v.price) {
          cpEl.textContent = fmtMoney(v.compareAtPrice);
          cpEl.hidden = false;
        } else {
          cpEl.hidden = true;
        }
      }

      /* Quick-buy drawer: its header price and ADD TO CART bar sit outside the
         modal and used to wait for the product:rerender fetch (~1.5s). Paint
         them now from the inline JSON; the rerender still lands afterwards. */
      var drawerContent = modal.closest('#quick-buy-modal-content');
      if (drawerContent) {
        var d2 = discPct(v.price, v.compareAtPrice);
        setPriceText(drawerContent.querySelector('.quick-variant-info sale-price'), fmtMoney(v.price));
        var hCmp = drawerContent.querySelector('.quick-variant-info compare-at-price');
        if (hCmp) { hCmp.hidden = !d2; if (d2) setPriceText(hCmp, fmtMoney(v.compareAtPrice)); }
        var hOff = drawerContent.querySelector('.quick-variant-info .discountPercentage');
        /* price-list.liquid floors (integer divided_by); rounding here showed
           -58% then flipped to -57% when the fetched header landed. */
        var dFloor = d2 ? Math.floor((v.compareAtPrice - v.price) * 100 / v.compareAtPrice) : 0;
        if (hOff) { hOff.hidden = !d2; if (d2) hOff.textContent = '-' + dFloor + '%'; }
        var buy = drawerContent.querySelector('.custom-buy');
        if (buy) {
          var bMain = buy.querySelector('.buybutton-main-price');
          if (bMain) bMain.textContent = fmtMoney(v.price);
          var bCmp = buy.querySelector('.buybutton-compareat-price');
          if (bCmp) { bCmp.hidden = !d2; if (d2) bCmp.textContent = fmtMoney(v.compareAtPrice); }
          var bBtn = buy.querySelector('[variant-id]');
          if (bBtn) bBtn.setAttribute('variant-id', v.id);
        }
      }

      /* Toggle ATC / Notify Me based on availability */
      var atcBtnEl       = byId('gnc-vm-atc-' + pid);
      var notifyContainer = byId('gnc-vm-notify-container-' + pid);
      var notifyBtnEl     = modal.querySelector('.gnc-vm-notify-btn');
      if (atcBtnEl && notifyContainer) {
        atcBtnEl.hidden       = !v.available;
        notifyContainer.hidden = !!v.available;
        if (!v.available && notifyBtnEl) {
          notifyBtnEl.dataset.variantId       = v.id;
          notifyBtnEl.dataset.variantTitle    = v.title;
          notifyBtnEl.dataset.sku             = v.sku || '';
          notifyBtnEl.dataset.price           = v.price;
          notifyBtnEl.dataset.compareAtPrice  = v.compareAtPrice || 0;
          /* Reset or preserve 'Notified' state per variant */
          if (_notifiedVariants[v.id]) {
            notifyBtnEl.textContent = 'Notified';
            notifyBtnEl.disabled = true;
          } else {
            notifyBtnEl.textContent = 'Notify Me';
            notifyBtnEl.disabled = false;
          }
        }
      }
    }

    /* ─ Track Notify Me submissions via MutationObserver ─ */
    var notifyBtn = modal.querySelector('.gnc-vm-notify-btn');
    if (notifyBtn) {
      new MutationObserver(function () {
        if (notifyBtn.textContent.trim() === 'Notified' && notifyBtn.dataset.variantId) {
          _notifiedVariants[notifyBtn.dataset.variantId] = true;
        }
      }).observe(notifyBtn, { childList: true, characterData: true, subtree: true });
    }

    /* ─ refresh pill selected / disabled / price after a selection ─ */
    function refreshPills(changedIdx) {
      var groups = modal.querySelectorAll('.gnc-vm-option-group');
      groups.forEach(function (group, gi) {
        group.querySelectorAll('.gnc-vm-pill').forEach(function (pill) {
          var ov  = pill.dataset.optionValue;
          var sel = (state.opts[gi] === ov);

          pill.classList.toggle('gnc-vm-pill--selected', sel);
          pill.setAttribute('aria-pressed', sel ? 'true' : 'false');

          /* The label belongs to the full combination (this card's value +
             every other selected option), so it is re-resolved on ANY change,
             including a flavour change that comes after the Size group. */
          if (gi === labelIdx) {
            var lV = data.variants.find(function (v) {
              return v.options.every(function (o, i) { return i === gi ? o === ov : o === state.opts[i]; });
            }) || null;
            var le = pill.querySelector('.gnc-vm-pill-offer-label');
            var newLabel = (lV && lV.offerLabel) ? lV.offerLabel : '';
            if (newLabel) {
              if (!le) {
                le = document.createElement('span');
                le.className = 'gnc-vm-pill-offer-label';
                pill.insertBefore(le, pill.firstChild);
              }
              le.textContent = newLabel;
              le.hidden = false;
            } else if (le) {
              le.hidden = true;
            }
          }

          /* Only recalculate availability / prices for groups after the changed one */
          if (gi > changedIdx) {
            var testOpts = state.opts.slice();
            testOpts[gi] = ov;

            /* Does this combo exist at all? (any variant with matching preceding opts + this value) */
            var exists = data.variants.some(function (v) {
              return testOpts.every(function (o, i) { return i > gi || v.options[i] === o; });
            });
            /* Is it in stock? */
            var avail = exists && data.variants.some(function (v) {
              return testOpts.every(function (o, i) { return i > gi || v.options[i] === o; }) && v.available;
            });

            /* Unavailable combo → hide entirely */
            pill.hidden = !exists;
            pill.dataset.comboExists = exists ? 'true' : 'false';
            /* Sold out (exists but unavailable) → show disabled */
            pill.classList.toggle('gnc-vm-pill--soldout', exists && !avail);
            pill.classList.remove('gnc-vm-pill--disabled');
            pill.setAttribute('aria-disabled', (exists && !avail) ? 'true' : 'false');

            /* last group: refresh per-pill price / servings / discount */
            if (gi === lastIdx) {
              var mV = data.variants.find(function (v) {
                return v.options.every(function (o, i) { return i === gi ? o === ov : o === state.opts[i]; });
              }) || null;
              pill.dataset.variantId = mV ? String(mV.id) : '';

              /* Per-ounce depends on BOTH the flavour's price and the selected
                 size, so it has to be recomputed here or it goes stale the
                 moment the size changes. */
              var oze = pill.querySelector('.gnc-vm-pill-peroz');
              if (oze) {
                var szVal   = (data.sizeOptIndex >= 0) ? state.opts[data.sizeOptIndex] : null;
                var szKey   = szVal ? String(szVal).replace(/\s+/g, '').toLowerCase() : null; /* keys are normalised in Liquid */
                var ozUnits = (szKey && data.ozBySize) ? data.ozBySize[szKey] : null;
                var gmUnits = (szKey && data.gmBySize) ? data.gmBySize[szKey] : null;
                /* Write the two unit spans separately -- setting textContent on
                   the wrapper would delete them, and applyUnitVisibility() needs
                   both present to swap on the LBS/KGS toggle. */
                var lbsEl = oze.querySelector('.option-lbs');
                var kgsEl = oze.querySelector('.option-kgs');
                if (mV && ozUnits && gmUnits) {
                  var pOz = Math.round(mV.price / ozUnits);
                  var pGm = Math.round(mV.price / gmUnits);
                  if (lbsEl) lbsEl.textContent = '\u20B9' + Math.floor(pOz / 100) + '.' + String(pOz % 100).padStart(2, '0') + '/Oz';
                  if (kgsEl) kgsEl.textContent = '\u20B9' + Math.floor(pGm / 100) + '.' + String(pGm % 100).padStart(2, '0') + '/g';
                  oze.hidden = false;
                } else {
                  oze.hidden = true;
                }
              }

              var pe = pill.querySelector('.gnc-vm-pill-price');
              var se = pill.querySelector('.gnc-vm-pill-servings');
              var de = pill.querySelector('.gnc-vm-pill-discount');

              if (mV) {
                if (pe) { pe.textContent = fmtMoney(mV.price); pe.hidden = false; }
                if (se) { se.hidden = !mV.servings; if (mV.servings) se.textContent = '(' + mV.servings + ')'; }
                if (de) {
                  var dpct = discPct(mV.price, mV.compareAtPrice);
                  de.hidden = (dpct === 0);
                  if (dpct > 0) de.textContent = dpct + '% off';
                }
              } else {
                if (pe) pe.hidden = true;
                if (de) de.hidden = true;
              }
            }
          }
        });
      });
    }

    /* ─ sync helpers ──────────────────────────────────────── */

    function getOptionIds() {
      var v = data.variants.find(function (v) { return v.id === state.vid; });
      if (!v) return null;
      var idMap = data.optionValueIdMap;
      return v.options.map(function (optVal, i) {
        var optName = data.options[i];
        return idMap[optName] && idMap[optName][optVal] ? String(idMap[optName][optVal]) : optVal;
      });
    }

    /* syncToPDP — calls selectCombination on pill click.
       Fetches fresh section HTML → product:rerender updates gallery,
       price, buy-buttons, URL, GNC Cash, etc. Modal stays alive
       because it's rendered outside <product-rerender>.
       Debounced: rapid pill taps only fire the last call. */
    /*
      Debounce raised from 120ms to 400ms.

      Each run of this timer calls selectCombination(), which fetches fresh
      section HTML and re-renders the PDP behind the modal — gallery, price,
      buy-buttons, URL, GNC Cash. At 120ms a shopper comparing sizes fires one
      full re-render per pill tap, because the gap between taps is normally
      longer than the debounce, so nothing actually collapses.

      Measured on /products/gnc-pro-performance-weight-gainer, mobile, 4x CPU
      throttle, six pill taps 250ms apart, alternating runs:

        120ms debounce -> 15 long tasks / 2089ms blocking, 13 / 1398ms
        400ms debounce ->  8 long tasks /  989ms blocking,  5 /  683ms

      About half the blocking work, consistently. This matters because RUM
      attributes 260 poor interactions on these PDPs to TimerHandler:setTimeout
      at 555ms average, and the field profile is input-delay dominated
      (345-537ms delay against 19-134ms processing) — the taps are waiting on a
      busy thread, not on a slow handler, so the fix is to generate less work
      rather than to speed the handler up.

      400ms is invisible to the shopper: the modal's own UI already updates on
      the next frame via requestAnimationFrame, and this timer only syncs the
      PDP behind the sheet.
    */
    var _productJson = null, _prevVariant = null;
    function getProductJson() {
      if (!_productJson) {
        _productJson = fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + data.productHandle + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { _productJson = null; return null; });
      }
      return _productJson;
    }

    /* Quick-buy drawer: dots loader on ADD TO CART while the fetch for the new
       variant is in flight. Shoppers saw the price paint, then the bar repaint
       a second later, and could add in between (GNC-184 retest). The swapped-in
       button arrives without aria-busy, which ends the loader. */
    function setDrawerBusy(on) {
      var content = modal.closest('#quick-buy-modal-content');
      var btn = content && content.querySelector('.custom-buy button');
      if (!btn) return;
      if (on) btn.setAttribute('aria-busy', 'true');
      else btn.removeAttribute('aria-busy');
    }

    /* Swap only the drawer's header price/image and buy bar from the fetched
       page. A full product:rerender also replaced this modal, so the pills
       re-initialised and the Size row jumped back -- the second "refresh". */
    function applyDrawerFragment(content, frag) {
      var fresh = frag.querySelector('#quick-buy-modal-content');
      if (!fresh) return;
      var swap = function (sel, onlyIfChanged) {
        var oldEl = content.querySelector(sel), newEl = fresh.querySelector(sel);
        if (!oldEl || !newEl) return null;
        if (onlyIfChanged && oldEl.outerHTML === newEl.outerHTML) return null;
        oldEl.replaceWith(newEl);
        return newEl;
      };
      /* Image only when it is a different file, or it flashes while reloading. */
      var oldImg = content.querySelector('.quick-variant-image img');
      var newImg = fresh.querySelector('.quick-variant-image img');
      if (oldImg && newImg && oldImg.getAttribute('src') !== newImg.getAttribute('src')) swap('.quick-variant-image');
      swap('.quick-variant-info .price-list', true);
      var buy = swap('.custom-buy');
      var buyBtn = buy && buy.querySelector('button:not(.notify-me-btn)');
      /* Same binding <product-rerender> gives the buttons it renders. */
      if (buyBtn && typeof window.quickViewPopupAdd === 'function') window.quickViewPopupAdd(buyBtn);
    }

    function syncToPDP() {
      if (_syncTimer) clearTimeout(_syncTimer);
      if (isInline) setDrawerBusy(true);
      _syncTimer = setTimeout(function () {
        _syncTimer = null;
        var optionIds = getOptionIds();
        if (!optionIds) { if (isInline) setDrawerBusy(false); return; }

        /* Check radios */
        var form = getForm();
        if (form && form.elements) {
          optionIds.forEach(function (valId, i) {
            var pos = String(i + 1);
            for (var j = 0; j < form.elements.length; j++) {
              var el = form.elements[j];
              if (el.type === 'radio' &&
                  el.getAttribute('data-option-position') === pos &&
                  el.value === valId) {
                el.checked = true;
                break;
              }
            }
          });
        }

        /* selectCombination: fetch fresh HTML → product:rerender + variant:change */
        var vp = !isInline && document.querySelector('variant-picker[form-id="' + data.formId + '"]');
        if (vp && typeof vp.selectCombination === 'function') {
          vp.selectCombination({ optionValues: optionIds, productChange: false });
        } else if (form && state.vid) {
          /* Quick-buy drawer: no <variant-picker> to delegate to, so set the
             form's variant id ourselves (otherwise the cart gets the first
             variant) and fire the theme's variant:change so price, buy button
             and media listening on this form update too. */
          var vid = state.vid;
          var idInput = form.querySelector('[name="id"]');
          if (idInput) idInput.value = vid;
          /* Same path the theme's variant-picker uses in quick_buy context:
             fetch the product page for this combination, then swap in the
             fresh header price / image / buy button (applyDrawerFragment). */
          fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'products/' + data.productHandle + '?option_values=' + optionIds.join(','))
            .then(function (r) { return r.text(); })
            .then(function (html) {
              if (state.vid !== vid) return; /* a newer pick owns the loader */
              var content = modal.closest('#quick-buy-modal-content');
              if (!content || !document.body.contains(content)) return;
              /* DOMParser, not createContextualFragment: the latter builds the
                 whole PDP against the live document, so every image and video on
                 that page started downloading on each variant pick. */
              var tpl = new DOMParser().parseFromString(html, 'text/html').getElementById('quick-buy-content');
              if (tpl) applyDrawerFragment(content, tpl.content);
              setDrawerBusy(false);
            })
            .catch(function () { if (state.vid === vid) setDrawerBusy(false); });
          getProductJson().then(function (p) {
            if (!p || state.vid !== vid) return;
            var v = p.variants.find(function (x) { return x.id === vid; });
            if (!v) return;
            form.dispatchEvent(new CustomEvent('variant:change', {
              bubbles: true,
              detail: { formId: form.id, variant: v, previousVariant: _prevVariant }
            }));
            _prevVariant = v;
          });
        } else if (isInline) {
          setDrawerBusy(false);
        }
      }, modal.hasAttribute('data-gnc-vm-inline') ? 150 : 400); /* drawer: no PDP behind it to re-render, so the long debounce only added lag */
    }

    /* ─ pill click ─ */
    modal.addEventListener('click', function (e) {
      /* Ignore close-modal targets */
      if (e.target.closest('[data-gnc-close]')) return;

      /* KG/LB unit toggle */
      var unitBtn = e.target.closest('.gnc-vm-unit-btn');
      if (unitBtn) {
        var unit = unitBtn.dataset.unit;
        modal.querySelectorAll('.gnc-vm-unit-btn').forEach(function (b) {
          b.classList.toggle('active', b.dataset.unit === unit);
        });
        /* On a PDP, variant-picker.liquid owns #checkbox-lbskgs and its
           applyUnitVisibility(); proxy to it so there is one source of truth.
           In the quick-buy drawer that component is not on the page at all, so
           the checkbox is missing and the toggle did nothing — apply the same
           class swap directly. Guarded on the checkbox so the two never both
           run and fight over the same elements. */
        var cb = document.getElementById('checkbox-lbskgs');
        if (cb) {
          cb.checked = (unit === 'kg');
          cb.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          applyUnitClassesDirect(unit === 'kg', modal);
        }
        /* Update footer variant text to reflect the new unit */
        updateFooter();
        return;
      }

      /* Variant pill — allow sold-out pills (show Notify Me), block only hidden combos */
      var pill = e.target.closest('.gnc-vm-pill');
      if (!pill || pill.hidden) return;

      var idx = parseInt(pill.dataset.optionIndex, 10);
      var val = pill.dataset.optionValue;
      if (state.opts[idx] === val) { revealSelected(modal); return; }

      var best = bestVariant(idx, val);
      if (best) { state.opts = best.options.slice(); state.vid = best.id; }
      else       { state.opts[idx] = val; state.vid = null; }

      /* Defer modal DOM work to next frame — keeps INP low */
      requestAnimationFrame(function () {
        refreshPills(idx);
        updateFooter();
        revealSelected(modal); /* a half-visible card stayed clipped after tapping it (GNC-BUG-58) */
      });

      /* Sync PDP: selectCombination updates gallery, price, URL, etc. */
      syncToPDP();

      /* Scroll so gnc-vm-wrapper stays visible in background behind the modal.
         PDP only: a drawer for the same product must not scroll the page. */
      var wrapper = !isInline && document.querySelector('.gnc-vm-wrapper[data-product-id="' + pid + '"]');
      if (wrapper) { wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });

    /* ─ ATC button — delegates entirely to the native ProductForm CE ── */
    var atcBtn = byId('gnc-vm-atc-' + pid);
    if (atcBtn) {
      atcBtn.addEventListener('click', function () {
        if (!state.vid || atcBtn.getAttribute('aria-busy') === 'true') return;

        /* Block if selected variant is sold out */
        var currentV = data.variants.find(function (v) { return v.id === state.vid; });
        if (!currentV || !currentV.available) return;

        /* 1. Sync the page's product form hidden input with the selected variant */
        var form = getForm();
        if (!form) return;
        var hiddenId = form.querySelector('input[name="id"]');
        if (hiddenId) { hiddenId.removeAttribute('disabled'); hiddenId.value = String(state.vid); }

        /* 2. Show loading state on modal button */
        atcBtn.setAttribute('aria-busy', 'true');

        /* 3. When cart:change fires (ProductForm CE dispatches it after a successful add),
              close the modal. The drawer opens automatically via CartDrawer._onVariantAdded. */
        var cartTimeout;
        document.documentElement.addEventListener('cart:change', function handler() {
          document.documentElement.removeEventListener('cart:change', handler);
          clearTimeout(cartTimeout);
          atcBtn.removeAttribute('aria-busy');
          requestAnimationFrame(function () { updateTriggerLabel(); });
          closeModal(modal);
        });

        /* 4. Safety: remove busy state on cart:error too */
        form.addEventListener('cart:error', function errHandler() {
          form.removeEventListener('cart:error', errHandler);
          clearTimeout(cartTimeout);
          atcBtn.removeAttribute('aria-busy');
        });

        /* 4b. Timeout safety: if neither event fires within 10s, reset button */
        cartTimeout = setTimeout(function () {
          atcBtn.removeAttribute('aria-busy');
        }, 10000);

        /* 5. Submit — syncToPDP already ensures the correct variant is selected.
              ProductForm CE does the rest: fetch /cart/add.js, variant:add, cart:change. */
        form.requestSubmit();
      });
    }

    /* ─ update inline trigger bar label ─ */
    function updateTriggerLabel() {
      var v = data.variants.find(function (v) { return v.id === state.vid; });
      if (!v) return;
      var trigBtn = document.getElementById('gnc-vm-open-' + pid);
      if (!trigBtn) return;
      var lbl = trigBtn.querySelector('.gnc-vm-trigger-label');
      if (!lbl) return;
      lbl.textContent = '';
      if (v.emoji) {
        var img = document.createElement('img');
        img.src = v.emoji;
        img.className = 'gnc-vm-pill-emoji-img';
        img.width = 20;
        img.height = 20;
        img.alt = '';
        img.setAttribute('aria-hidden', 'true');
        img.style.marginRight = '4px';
        lbl.appendChild(img);
      }
      var txt = v.options.join('\u00A0|\u00A0');
      if (v.servings) txt += '\u00A0(' + v.servings + ')';
      lbl.appendChild(document.createTextNode(txt));
    }

    /*
      When the main PDP variant:change fires (e.g. deep-link URL pre-selection),
      sync the modal's internal state so it reflects the correct pre-selected state.
      Skip if already in sync (our own selectCombination fires this too).
    */
    document.addEventListener('variant:change', function (e) {
      if (!e.detail || !e.detail.variant) return;
      /* Only our own form: the quick-buy drawer and the PDP can show the same
         product, and one must not drive the other. Also stops copies detached
         by the drawer's re-render from reacting. */
      if (e.detail.formId && e.detail.formId !== data.formId) return;
      /* Two drawers for one product share a form id; only ours counts. */
      if (isInline && e.target !== getForm()) return;
      if (!document.body.contains(modal)) return;
      var v = data.variants.find(function (v) { return v.id === e.detail.variant.id; });
      if (!v) return;
      if (v.id === state.vid) return;  /* skip if already in sync (e.g. our own selectCombination) */
      state.opts = v.options.slice();
      state.vid  = v.id;
      /* Always update footer (for lbs/kgs sync) regardless of modal state */
      updateFooter();
      /* Only update pills if modal is currently open */
      if (!modal.hasAttribute('hidden')) {
        requestAnimationFrame(function () {
          refreshPills(-1);
        });
      }
      updateTriggerLabel();
    });

    /* Initial footer update — ensures lbs/kgs matches toggle state on first open */
    updateFooter();
  }

  /* ═══════════════════════════════════════════════════════════
     Delegated global listeners — single attachment each,
     bubble-only, no capture — minimal INP overhead.
  ═══════════════════════════════════════════════════════════ */
  document.addEventListener('click', function (e) {
    /* Open */
    var openBtn = e.target.closest('[id^="gnc-vm-open-"]');
    if (openBtn) {
      var pid = openBtn.id.replace('gnc-vm-open-', '');
      if (!_inited[pid]) { setupModal(pid); _inited[pid] = true; }
      openModal(pid);
      return;
    }
    /* Close */
    var closeEl = e.target.closest('[data-gnc-close]');
    if (closeEl) {
      var m = closeEl.closest('.gnc-vm-modal');
      if (m) closeModal(m);
    }
  });

  /* ─────────────────────────────────────────────────────────────
     Inline mode (quick-buy drawer).

     The drawer fetches the PDP and injects markup; nothing clicks a trigger,
     so setupModal() would never run. Anything carrying data-gnc-vm-inline is
     initialised as soon as it appears. Purely additive — the PDP's
     click-to-open path is untouched.
     ───────────────────────────────────────────────────────────── */
  function initInline(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll ? scope.querySelectorAll('[data-gnc-vm-inline]') : [];
    Array.prototype.forEach.call(nodes, function (el) {
      var pid = (el.id || '').replace('gnc-vm-modal-', '');
      /* Guard per element, not per product: every drawer that loads this
         product (PLP card, search card) gets its own copy with the same ids,
         and each copy needs its own listeners. */
      if (!pid || el._gncVmInited) return;
      if (setupModal(pid, el) === false) return;
      el._gncVmInited = true;
      requestAnimationFrame(function () { revealSelected(el); });
    });
  }

  if (document.readyState !== 'loading') initInline(document);
  else document.addEventListener('DOMContentLoaded', function () { initInline(document); });

  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.hasAttribute && n.hasAttribute('data-gnc-vm-inline')) initInline(n.parentNode || document);
        else if (n.querySelector && n.querySelector('[data-gnc-vm-inline]')) initInline(n);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* One quick-buy drawer at a time. On iOS (search → whey → change variant →
     close) a second drawer was left open underneath and had to be closed
     again. DialogElement fires `toggle` when `open` changes; when one drawer
     opens, hide any other that is still open. */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'QUICK-BUY-DRAWER' || !d.hasAttribute('open')) return;
    document.querySelectorAll('quick-buy-drawer[open]').forEach(function (other) {
      if (other !== d && typeof other.hide === 'function') other.hide();
    });
    /* closeModal() (after add-to-cart, or Esc) hides the inline modal, but the
       drawer keeps its cached content -- reopening showed an empty drawer that
       just flickered. Un-hide it on every open. */
    d.querySelectorAll('.gnc-vm-modal--inline[hidden]').forEach(function (m) { m.removeAttribute('hidden'); });
    /* The drawer is display:none while closed, which drops the Size row's
       scrollLeft. Reopened with cached content (no initInline), a selected
       last card (Weight Gainer 5 KG) sat off-screen. */
    requestAnimationFrame(function () {
      d.querySelectorAll('.gnc-vm-modal--inline').forEach(revealSelected);
    });
  }, true);

  /* Notify Me over the quick-buy drawer: the drawer's focus trap treated taps
     in the modal as outside taps. On touch it cancels the touchstart (no click)
     and hides the drawer, so the first tap on × only closed the drawer behind
     and a second tap was needed. It would also pull focus out of the email
     field. Pause the trap while the modal is shown. */
  (function () {
    var nm = document.getElementById('notify-me-modal');
    if (!nm) return;
    var paused = [];
    new MutationObserver(function () {
      if (nm.classList.contains('show')) {
        document.querySelectorAll('quick-buy-drawer[open]').forEach(function (d) {
          if (d._focusTrap && paused.indexOf(d) < 0) { d._focusTrap.pause(); paused.push(d); }
        });
      } else {
        paused.forEach(function (d) { if (d._focusTrap) d._focusTrap.unpause(); });
        paused = [];
      }
    }).observe(nm, { attributes: true, attributeFilter: ['class'] });
  }());

  /* Keyboard: Esc closes open modal */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var m = document.querySelector('.gnc-vm-modal:not([hidden])');
    if (m) closeModal(m);
  });

}());
